import React from 'react';
import './LoadingOverlay.scss';

export default function LoadingOverlay() {
	return(
		<div className="loadingOverlay flex align-items-center justify-content-center">
			<div className="loadingOverlay__spinner"><div /><div /><div /></div>
		</div>
	)
}